import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageSectionHeading from '../../PageSectionHeading';
import { colors, typography } from '../../../styles';

const styles = css`
  padding: 45px 0;
  background-color: ${colors.neutral};
  position: relative;
  z-index: 2;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .GreenBuildingNumberedCard_content {
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .GreenBuildingNumberedCard {
    width: 100%;
    margin: 0;
    padding: 30px;
    text-align: left;
    border-right: 2px solid ${colors.white};
    border-bottom: 2px solid ${colors.white};
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background-image: linear-gradient(153deg, rgba(52,89,37,0.3) 0%, #345925 80%);
    @media (min-width: 1200px) {
      width: 50%;
      flex-direction: row;
      padding: 60px;
    }
    &:nth-child(3) {
      background: linear-gradient(188deg, rgba(52,89,37,0.3) 0%, #345925 70%);
    }
  }
  .GreenBuildingNumberedCard_number {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background-color: ${colors.white};
    text-align: center;
    line-height: 86px;
    font-size: 42px;
    font-weight: 700;
    font-family: ${typography.Serif};
    flex-shrink: 0;
    margin: 0 0 15px 0;
    @media (min-width: 1200px) {
      width: 115px;
      height: 115px;
      line-height: 112px;
      margin: 0 30px 0 0;
    }
  }
  .GreenBuildingNumberedCard_title {
    font-size: 21px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0;
    line-height: 1;
    color: ${colors.white};
    margin: 15px 0 0 0;
    @media (min-width: 1200px) {
      font-size: 23px;
      margin: 30px 0 0 0;
    }
  }
  .GreenBuildingNumberedCard_textSectionWrapper {
    display: flex;
    flex-direction: column;
    @media (min-width: 1200px) {
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .GreenBuildingNumberedCard_textSection {
    width: 100%;
    @media (min-width: 1200px) {
      width: calc(50% - 30px);
    }
  }
  .GreenBuildingNumberedCard_textSectionHeading {
    font-size: 21px;
    font-weight: 600;
    line-height: 1.3;
    margin: 30px 0 20px 0;
    color: ${colors.white};
    border-bottom: 1px solid ${colors.body};
    padding: 0 0 20px 0;
  }
  .GreenBuildingNumberedCard_textSectionText {
    p {
      font-size: 21px;
      font-weight: 600;
      line-height: 1.3;
      margin: 0 0 30px 0;
      color: ${colors.white};
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    li {
      font-size: 21px;
      font-weight: 400;
      line-height: 1.3;
      margin: 0 0 30px 0;
      padding: 0 0 0 20px;
      position: relative;
      color: ${colors.white};
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 8px;
        left: 0;
        width: 8px;
        height: 8px;
        background-color: #C1EE4A;
      }
    }
    a {
      font-weight: 700;
      color: ${colors.color4};
    }
  }
`;


function GreenBuildingNumberedCards({ content }) {
  return (
    <section className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} underdog />
      }
      <div className="container">
        <div className="GreenBuildingNumberedCard_content" style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, '[0].background_image.contentUrl'), { width: 2000, height: 2000 })})` }}>
          {
            get(content, '[0].cards' || []).map((item, index) => {
              return (
                <div className="GreenBuildingNumberedCard" key={item.title}>
                  <div className="GreenBuildingNumberedCard_number">{index + 1}</div>
                  <div>
                    {
                      get(item, 'title') &&
                      <h3 className="GreenBuildingNumberedCard_title">{get(item, 'title')}</h3>
                    }
                    {
                      get(item, 'text_sections').length > 0 &&
                      <div className="GreenBuildingNumberedCard_textSectionWrapper">
                        {
                          get(item, 'text_sections' || []).map(section => {
                            return (
                              <div className="GreenBuildingNumberedCard_textSection">
                                <h4 className="GreenBuildingNumberedCard_textSectionHeading">{get(section, 'heading')}</h4>
                                <div className="GreenBuildingNumberedCard_textSectionText" dangerouslySetInnerHTML={SanitizeHtml(get(section, 'text'))} />
                              </div>
                            );
                          })
                        }
                      </div>
                    }
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </section>
  );
}

GreenBuildingNumberedCards.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default GreenBuildingNumberedCards;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/GreenBuildingNumberedCards.section.js